import { render, staticRenderFns } from "./skillsChart.vue?vue&type=template&id=76138b4b&scoped=true"
import script from "./skillsChart.vue?vue&type=script&lang=js"
export * from "./skillsChart.vue?vue&type=script&lang=js"
import style0 from "./skillsChart.vue?vue&type=style&index=0&id=76138b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76138b4b",
  null
  
)

export default component.exports